import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {
  Inspection,
  InspectionDetailComponent,
  InspectionFormComponent,
  Machine,
  MachineDetailComponent,
  RouterService,
  StateService,
  ToolService,
} from 'projects/shared/src/public-api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lib-inspection-overview',
  templateUrl: './inspection-overview.component.html',
  styleUrls: ['./inspection-overview.component.scss'],
  standalone: false,
})
export class InspectionOverviewComponent implements OnInit {
  constructor(
    public routerService: RouterService,
    public state: StateService,
    public modalCtrl: ModalController,
    public toolService: ToolService
  ) {}

  allEntries: Inspection[] = [];

  sub: Subscription;

  ngOnInit() {
    this.sub = this.state.inspections$.subscribe((x) => (this.allEntries = x));
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  async openDetailModal(id: string) {
    const modal = await this.modalCtrl.create({
      component: InspectionDetailComponent,
      componentProps: {
        paramId: id,
      },
    });
    modal.present();
    const { data, role } = await modal.onWillDismiss();
    if (role === 'confirm') {
      if (data == 'edit') {
        this.openFormModal(id);
      } else if (data == 'view') {
        await this.state.openFile(id, 'inspection');
      }
    }
  }

  async openFormModal(id: string) {
    const modal = await this.modalCtrl.create({
      component: InspectionFormComponent,
      componentProps: {
        paramId: id,
      },
    });
    modal.present();
    const { data, role } = await modal.onWillDismiss();
    if (role === 'confirm' && id != null) {
      this.openDetailModal(id);
    }
  }
}
